import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
//import { Menu } from './dados-menu';
import { animate, style, transition, trigger } from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalService } from '../../services/modal.service';
import { FormBuilder } from '@angular/forms';
import { PermissionService } from '../../services/permission.service';
import { s } from '@fullcalendar/core/internal-common';



@Component({
  selector: 'app-menu-lateral',
  templateUrl: './menu-lateral.component.html',
  styleUrls: ['./menu-lateral.component.scss'],
  animations: [
      trigger('onOff', [
        transition(':enter', [style({
          opacity: 0,
          transform: 'translateY(-100%)'
        }),
        animate(400)
        ])
      ]),
      trigger('onShowImage', [
        transition(':enter', [style({
          opacity: 0,
          //transform: 'scale(1)'
        }),
        animate(1000)
      ])
    ]),
  ]
})
export class MenuLateralComponent implements OnInit {

  clicked: any = false
  menuAberto: boolean = false;
  dropState: any = false;
  Menu: any[] = []

  

  index = 0;
  menu!: any;
  expand: any = {};

  @Input() open: boolean = false;
  @Output() openChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  selectedNode = undefined;

  finantialMenu = this.fb.group({
    revenue: this.fb.group({
      active: false,
      data: {
        path: '/financeiro/receita',
        title: 'Receita',
        icon: '/assets/icons/receitas.svg',
        submenu: [],
      }
    }),
    cash_expense: this.fb.group({
      active: false,
      data: {
        path: '/financeiro/despesaCaixa',
        title: 'Despesa Caixa',
        icon: '/assets/icons/despesa_caixa.svg',
        submenu: [],
      }
    }),
    bank_expense: this.fb.group({
      active: false,
      data: {
        path: '/financeiro/despesaBancarias',
        title: 'Despesas Bancárias',
        icon: '/assets/icons/despesas_bancarias.svg',
        submenu: [],
      }
    }),
    cash: this.fb.group({
      active: false,
      data: {
        path: '/financeiro/caixa',
        title: 'Caixa',
        icon: '/assets/icons/caixa.svg',
        submenu: [],
      }
    }),
    invoices: this.fb.group({
      active: false,
      data: {
        path: '/notas-fiscais',
        title: 'Nota Fiscal',
        icon: '/assets/icons/notas_fiscais.svg',
        submenu: [],
      }
    })
  });

  /*
     entrega_exame: this.fb.group({
      active: false,
      data: {
        path: 'entrega-exame/home',
        title: 'Entrega de exame',
        icon: '/assets/icons/p-calendar.svg',
        submenu: [],
      }
    }),
    payment_schedules: this.fb.group({
      active: false,
      data: {
        path: '/financeiro/calendarioPagamentos',
        title: 'Calendário de Pagamentos',
        icon: '/assets/icons/calendario_pgto.svg',
        submenu: [],
      }
    })
  */

  RegisterMenu = this.fb.group({
    units: this.fb.group({
      active: false,
      data: {
        path: '/cadastros/unidades',
        title: 'Unidades',
        submenu: [],
      },
    }),
    professional: this.fb.group({
      active: false,
      data: {
        path: 'cadastro/profissionais',
        title: 'Profissionais',
        submenu: [],
      }
    }),
    employee: this.fb.group({
      active: false,
      data: {
        path: 'cadastro/funcionarios',
        title: 'Funcionários',
        submenu: [],
      }
    }),
    payment_method: this.fb.group({
      active: false,
      data: {
        path: 'cadastro/forma-pagamento/home',
        title: 'Preferências',
        submenu: [],
      }
    }),
    register_data: this.fb.group({
      active: false,
      data: {
        path: 'cadastro/dados/home',
        title: 'Dados Cadastro',
        submenu: [],
      }
    }),
    exams: this.fb.group({
      active: false,
      data: {
        path: 'cadastro/exames',
        title: 'Exames',
        submenu: [],
      }
    }),
    service: this.fb.group({
      active: false,
      data: {
        path: 'cadastro/servico/home',
        title: 'Serviços',
        submenu: [],
      }
    })
  })

  reportMenu = this.fb.group({
    professional_transfers: this.fb.group({
      active: false,
      data: {
        path: '/relatorios/repassesProfissionais',
        title: 'Repasses Profissionais',
        submenu: [],
      }
    }),
    finantial: this.fb.group({
      active: false,
      data: {
        path: '/relatorios/financeiro',
        title: 'Financeiro',
        submenu: [],
      }
    }),
    bank: this.fb.group({
      active: false,
      data: {
        path: '/relatorios/bancario',
        title: 'Bancário',
        submenu: [],
      }
    })
  })

  professionalResultsMenu = this.fb.group({
    bank: this.fb.group({
      active: false,
      data: {
        path: '/relatorios/bancario',
        title: 'Bancário',
        submenu: [],
      }
    }),
    professionalResults: this.fb.group({
      active: false,
      data: {
        path: '/resultado-profissional',
        title: 'Resultado Profissional',
        submenu: []
    }})
  });

   professionalInvoices = this.fb.group({
      active: false,
      data: {
        path: '/profissionais/notas-ficais',
        title: 'Nota Fiscal',
        icon: '/assets/icons/notas_fiscais.svg',
        submenu: [],
      }
    });

  

  protected isAnimationEnd: boolean = false

  constructor(
    private router: Router,
    private modalService: ModalService,
    private fb: FormBuilder,
    private permissionService: PermissionService
  ) {
    // this.menu = this.Menu?.map((x: any) => this.toNode(x));
  }

  

  ngOnInit(): void {
    this.setMenuData()
  }

  getUrlSelected(node: any) {
    return this.router.url.indexOf(node.path) != -1;
  }


  taggle() {
    this.open = !this.open;
  }

  showMenu() {
    const width = window.innerWidth;
    if(width >= 600 && width <= 1024) return;
    this.open = true;
  }

  hideMenu() {
    const width = window.innerWidth;
    if(width >= 600 && width <= 1024) return;

    this.open = false;
    this.openChange.emit(this.open);
    this.closeAllOpenedSubmenus();
  }

  closeMenu() {
    this.open = false;
    this.openChange.emit(this.open);
    this.closeAllOpenedSubmenus();
  }


  private toNode(x: any): any {
    const y: any = { ...x };
    y.index = ++this.index;
    for (let n = 0; n < y.submenu.length; n++) {
      y.submenu[n] = this.toNode(y.submenu[n])
    }
    return y;
  }

  toggleVisible(node: any) {

    if (node.submenu && node.submenu.length > 0) {
      if (this.expand[node.index]) {
        this.expand[node.index] = false;
      } else {
        this.closeLastNode(node);
        this.expand[node.index] = true;

      }
    }
  }
  closeAllOpenedSubmenus() {
    Object.keys(this.expand).forEach(key => {
      this.expand[key] = false;
    });
  }
  closeLastNode(node: any) {
    for (let i in this.expand) {
      this.expand[i] = false;
    }
  }

  selectNode(node: any) {
    if (node.submenu.length <= 0) {
      if (node.externalLink) {
        window.open(node.link, '_blank');
      } else {
        this.router.navigateByUrl(node.path);
      }
      this.hideMenu();
    }
  }

  setMenuData() {
    const finantialForm = this.finantialMenu.controls
    const registerForm = this.RegisterMenu.controls
    const reportForm = this.reportMenu.controls
    const professionalResultsForm = this.professionalResultsMenu.controls
    const professionalInvoicesForm = this.professionalInvoices;
    const permissionList = this.permissionService.getPermissions()

    permissionList.forEach((p: any) => {
      switch(p.page){
        case 'receita':
          finantialForm.revenue.controls.active.setValue(true)
          break;
        case 'despesaCaixa':
          finantialForm.cash_expense.controls.active.setValue(true)
          break;
        case 'caixa':
          finantialForm.cash.controls.active.setValue(true)
          break;
        case 'despesaBancarias':
          finantialForm.bank_expense.controls.active.setValue(true)
          break;
        case 'notaFiscal':
          finantialForm.invoices.controls.active.setValue(true)
          break;
        case 'unidades':
          registerForm.units.controls.active.setValue(true)
          break;
        case 'profissionais':
          registerForm.professional.controls.active.setValue(true)
          break;
        case 'funcionarios':
          registerForm.employee.controls.active.setValue(true)
          break;
        case 'formaPagamento':
          registerForm.payment_method.controls.active.setValue(true)
          break;
        case 'dadosCadastro':
          registerForm.register_data.controls.active.setValue(true)
          break;
        case 'exames':
          registerForm.exams.controls.active.setValue(true)
          break;
        case 'servicos':
          registerForm.service.controls.active.setValue(true)
          break;
        case 'repassesProfissionaisReport':
          reportForm.professional_transfers.controls.active.setValue(true)
          break;
        case 'financeiroReport':
          reportForm.finantial.controls.active.setValue(true)
          break;
        case 'notasFiscaisReport':
          professionalInvoicesForm.controls.active.setValue(true);
          this.Menu.push(this.professionalInvoices.value.data);
          break;
        case 'resultado-profissional':
          professionalResultsForm.professionalResults.controls.active.setValue(true);
          professionalResultsForm.bank.controls.active.setValue(true);
        break;
        case 'bankReport':
          reportForm.bank.controls.active.setValue(true);
        break;

      }
    })

    let finantialData = Object.values(this.finantialMenu.value)
    let registerData = Object.values(this.RegisterMenu.value)
    let reportData = Object.values(this.reportMenu.value);

    let allowedFinantialData = finantialData.filter(data => data.active).map(item => item.data)
    let allowedRegisterData = registerData.filter(data => data.active).map(item => item.data)
    let allowedReportData = reportData.filter(data => data.active).map(item => item.data)


    if(this.professionalResultsMenu?.value?.professionalResults?.active == true){
      let professionalResult = this.professionalResultsMenu?.value.professionalResults?.data
      let bank = this.professionalResultsMenu?.value.bank?.data;

      this.Menu.push({
        path: '/relatorios',
        title: 'Relatórios',
        icon: '/assets/icons/p-relatorios.svg',
        submenu: [professionalResult, bank]
      });
      //this.Menu.push(this.professionalInvoices.value.data);
    } else {

      if (allowedFinantialData.length) {
        allowedFinantialData.forEach(data =>
          this.Menu.push(data)
        )
      }

      if (allowedRegisterData.length) {
        let submenu: any[] = []

        allowedRegisterData.forEach(data => {
          submenu.push(data)
        })

        this.Menu.push({
          path: '/cadastro',
          title: 'Cadastro',
          icon: '/assets/icons/p-cadastro.svg',
          submenu: submenu
        })
      }

      if (allowedReportData.length) {
        let submenu: any[] = []

        allowedReportData.forEach(data => {
          submenu.push(data)
        })

        this.Menu.push({
          path: '/relatorios',
          title: 'Relatórios',
          icon: '/assets/icons/p-relatorios.svg',
          submenu: submenu
        })
      }
    }
    
    
    this.menu = this.Menu?.map((x: any) => this.toNode(x));
  }

  animationEnd(event: any) {
    this.isAnimationEnd = true
  }
}
